










import { DataItem } from '@/services/analyzeCustom';
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import CustomTableView from './custom-table-view.vue';
@Component({
  components: { CustomTableView }
})
export default class PreviewTable extends Vue {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() info!: DataItem;

  bodyStyle = { backgroundColor: '#EEE'};
}
